import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

const SectionTemplatePage_SectionTemplate_UpdatePrintSettings_Mutation =
  graphql(`
    mutation SectionTemplatePage_SectionTemplate_UpdatePrintSettings(
      $printableId: Id!
      $printSettings: PrintSettingsInput!
    ) {
      updateSectionTemplatePrintSettings(
        printableId: $printableId
        printSettings: $printSettings
      ) {
        _id
      }
    }
  `);

export const useUpdateSectionTemplatePrintSettingsMutation = () =>
  useGraphQLMutation(
    SectionTemplatePage_SectionTemplate_UpdatePrintSettings_Mutation,
  );
